import React from "react";
import { CheckoutSection, hiddenAnchorStyle, OptionListItemRadio } from "../../components";
import { translateResourceString } from '../../../util/translationUtility';
import { Fade } from "../../componentAnimations";

const CheckoutShipmentPresentation = (
  {
    shippingOptions,
    selectedId,
    onSelected,
    isPendingRefresh,
    isStopWorkshop
  }) => {
    
  return (
      !isStopWorkshop &&
      (<CheckoutSection label='Shipping Method' hidden={false}>
      {isPendingRefresh
        ? <span className="fa fa-spinner fa-spin"/>
        : (
          <React.Fragment>
            {shippingOptions.length === 0 &&
                          <div>{translateResourceString("/Checkout/ShippingMethod/NoShippingMethodsAvailable")}</div>}

            <Fade inProp={true}>
              <div>{shippingOptions.map(sm => (
                <OptionListItemRadio
                  id={sm.Id}
                  key={sm.Id}
                  isSelected={(sm.Id === selectedId)}
                  onClick={onSelected}
                  label={sm.Name}
                  value={sm.Price}
                  className={'mb-1'}>
                    <div className="shipping-method-description text-sm">
                      <span>{sm.Description}</span>
                    </div>
                  </OptionListItemRadio>
            ))}
              </div>
            </Fade>
          </React.Fragment>
        )}
    </CheckoutSection>)
  );
};
        
export default CheckoutShipmentPresentation
